import type { FormValues } from "@/widgets/classic-form/form";
import {
    getEventsDetails,
    getFamilyMemberDetails,
    getGenderDetails,
    getNameDetails,
    getTimespanDetails,
} from "@/features/tree-person-transform";
import type { FormMetadataResponse } from "@/entities/form-metadata";
import type { Person } from "@/entities/tree-person";

export const transformPersonToFormValues = (
    person: Person,
    baseFormValues: FormValues,
    formMetadata: FormMetadataResponse,
    currentFormValues: FormValues,
    defaultYearProximity: number | null = null,
): FormValues => ({
    ...baseFormValues,
    name: getNameDetails(person, formMetadata),
    family: getFamilyMemberDetails(person.FamilyMembers, baseFormValues, formMetadata),
    events: getEventsDetails(person.LifeEvents, baseFormValues, formMetadata, defaultYearProximity),
    fields: getGenderDetails(person, baseFormValues, formMetadata),
    timespan: getTimespanDetails(baseFormValues, formMetadata, currentFormValues),
    treePerson: {
        personId: person.PersonId,
        treeId: person.TreeId,
    },
});
